import { MessageOperation, RequestOperation } from '@peercolab/engine'
import { Published } from '../../Core/PathItems'

export class CreateCourseCategory extends RequestOperation<CreateCourseCategoryInput,CourseCategory> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Categories.CreateCourseCategory",
      "CREATE",
      ["CourseCategoryId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class GetAllCourseCategorys extends RequestOperation<object,CourseCategory[]> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Categories.GetAllCourseCategorys",
      "GET",
      ["CourseCategoryId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class DeleteCourseCategory extends MessageOperation<object> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Categories.DeleteCourseCategory",
      "DELETE",
      ["CourseCategoryId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateCourseCategoryName extends MessageOperation<UpdateCourseCategoryNameInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Categories.UpdateCourseCategoryName",
      "PATCH",
      ["CourseCategoryId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateCourseCategoryState extends MessageOperation<UpdateCourseCategoryStateInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Categories.UpdateCourseCategoryState",
      "PATCH",
      ["CourseCategoryId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export type CreateCourseCategoryInput = {
  courseCategoryId?: string | undefined
  name: string
}

export type CourseCategory = {
  id: string
  name: string
  translationKey: string
  state: Published
}

export type UpdateCourseCategoryNameInput = {
  name: string
}

export type UpdateCourseCategoryStateInput = {
  /**
   * Valid values: publish, unpublish, revert
   */
  stateTransition: string
}

